var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPreguntasNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45,51.6c-1,0-1.9,0.9-1.9,1.9s0.9,1.9,1.9,1.9c1,0,1.9-0.9,1.9-1.9S46,51.6,45,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,35c-2.9,0-5.2,2.3-5.2,5.2c0,0.8,0.6,1.4,1.4,1.4c0.7,0,1.3-0.5,1.4-1.2l0-0.4c0.1-1.3,1.3-2.2,2.6-2.1 c1.2,0.1,2.1,1.1,2.1,2.4c0,1-0.3,1.5-1.2,2.5l-0.6,0.6c-1.4,1.5-2,2.6-2,4.5c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4 c0-1,0.3-1.5,1.2-2.5l0.6-0.6c1.4-1.5,2-2.6,2-4.5C50.2,37.3,47.9,35,45,35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,11c-18.8,0-34,15.2-34,34c0,18.8,15.2,34,34,34s34-15.3,34-34C79,26.2,63.8,11,45,11z M45,63.9c-3.1,0-6.1-0.7-8.8-2.2 L28,63.9c-0.9,0.2-1.7-0.3-2-1.2c-0.1-0.3-0.1-0.5,0-0.8l2.1-8.1C26.7,51.1,26,48,26,44.9c0-10.5,8.5-19,19-19c10.5,0,19,8.5,19,19 S55.5,63.9,45,63.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPreguntasNew);
export default __webpack_public_path__ + "static/media/ico-preguntas-new.6f292e378a529be48d780909ab076fca.svg";
export { ForwardRef as ReactComponent };